var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowfloorIconRooms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.667969 0 L 1.332031 0 L 1.332031 3 L 22.667969 3 Z M 24 15 L 24 12 L 22.667969 4.5 L 1.332031 4.5 L 0 12 L 0 15 L 1.332031 15 L 1.332031 24 L 14.667969 24 L 14.667969 15 L 20 15 L 20 24 L 22.667969 24 L 22.667969 15 Z M 12 21 L 4 21 L 4 15 L 12 15 Z M 12 21 "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowfloorIconRooms);
export default __webpack_public_path__ + "static/media/showfloor_icon_rooms.6fae0039.svg";
export { ForwardRef as ReactComponent };